import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import Loader from "../../Components/Loader/Loader";
import { SignUP } from "../../Utils/Api/SignUP";
import Captcha from "../../Components/ReCaptcha/Captcha";
import ReCAPTCHA from "react-google-recaptcha";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { useDispatch } from "react-redux";
import { getResendCode } from "../../redux/ResendCodeSlice";
import { getOTPCounterTime } from "../../redux/OTPCounterSlice";

const Acknowledgement = ({
  PrevBtn,
  BusinessInfoData,
  GeneralInfoData,
  tab_select,
  SetLoadingfuc,
  // componentDidMount,
}) => {
  const [check, setCheck] = useState(false);
  const [err_Display, setErr_Display] = useState("");
  const [capthaErr_Display, setCapthaErr_Display] = useState("");
  const [verfied, setVerifed] = useState(false);

  const PreviousTabHandler = () => {
    let ClickVal = 1;
    PrevBtn(ClickVal);
  };

  const onCheck = (e) => {
    setCheck(e.target.checked);
  };

  const SignUpHandler = (e) => {
    e.preventDefault();

    if (verfied === false) {
      setCapthaErr_Display("Please check the captcha");
    }

    if (
      verfied &&
      check &&
      BusinessInfoData.submitflag &&
      GeneralInfoData.submitflag === true
    ) {
      let signUpCredentials = {
        bu_first_name: GeneralInfoData.eu_first_name.trim(),
        bu_last_name: GeneralInfoData.eu_last_name.trim(),
        bu_contact_number: GeneralInfoData.eu_contact_number,
        bu_email: GeneralInfoData.eu_email.trim(),
        bu_address1: GeneralInfoData.bu_address_one.trim(),
        bu_address2: GeneralInfoData.bu_address_two.trim(),
        bu_country: GeneralInfoData.bu_country,
        bu_state: GeneralInfoData.bu_state,
        bu_city: GeneralInfoData.bu_city.trim(),
        bu_zip_code: GeneralInfoData.bu_zipCode.trim(),
        bu_name: BusinessInfoData.bu_Business_name.trim(),
        bu_registration_no: BusinessInfoData.bu_BusinessRegistration_no.trim(),
        bu_employee_count: BusinessInfoData.bu_BusinessEmployees,
        owned_gender: BusinessInfoData.bu_owned_gender,
        type: 1,
      };
      SignUpApiHandler(signUpCredentials);
    } else {
      setErr_Display("Please Enter all the Fields and then save!");
    }

    if (check === false) {
      setErr_Display("Please agree to the terms and conditions!");
    } else {
      setErr_Display("");
    }

    if (check === true) {
      tab_select(1);
    }
  };

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const SignUpApiHandler = async (data) => {
    SetLoadingfuc(true);
    const SignUpRes = await SignUP(data, () => {
      navigate("/");
    });
    if (SignUpRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      SetLoadingfuc(false);
    } else {
      if (SignUpRes.success === true) {
        toast.success(SignUpRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        dispatch(getResendCode(data));
        dispatch(getOTPCounterTime(SignUpRes.timer));
        navigate("/signup/OTP");
        SetLoadingfuc(false);
      } else {
        toast.error(SignUpRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        SetLoadingfuc(false);
      }
    }
  };

  function onChange(value) {
    setCapthaErr_Display("");
    if (!value) {
      setVerifed(false);
    } else {
      setVerifed(true);
    }
  }

  return (
    <>
      <Form className="my-5 pt-0" onSubmit={SignUpHandler}>
        <Form.Group className="mb-5 p-3 ack" controlId="formBasicCheckbox">
          <Form.Check
            onChange={onCheck}
            type="checkbox"
            className="SignUpTC"
            label={
              <>
                <p>I agree to the following:</p>
                <ul>
                  <li>
                    Freemium subscription starting at $0.00 per month and opt
                    into paid subscription.
                  </li>
                  <li>Voucher processing fees is 14% of the voucher value.</li>
                  <li>
                    Payouts for the voucher sales will be in the first week of
                    each month.
                  </li>
                  <li>
                    Agree to Meylah&nbsp;{" "}
                    <a
                      href="https://meylah.com/privacy-policy/"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                    <span style={{ color: "#fff" }}> &nbsp;and &nbsp;</span>
                    <a href="https://meylah.com/termsofuse/" target="_blank">
                      Terms & Conditions
                    </a>
                  </li>
                </ul>
              </>
            }
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1rem",
            }}
          >
            <ErrorLabel ErrorDisplay={err_Display} />
          </div>

          <ReCAPTCHA
            sitekey="6Levx3UrAAAAAMHowikpffj4w72mym_Q4lF7EAQA"
            onChange={onChange}
            className="captcha"
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1rem",
            }}
          >
            <ErrorLabel ErrorDisplay={capthaErr_Display} />
          </div>
          <button
            type="submit"
            className="btn btn-primary mt-3"
            style={{ display: "none" }}
          >
            Submit
          </button>
        </Form.Group>

        <div className="text-center small-btns d-flex ">
          <Link onClick={PreviousTabHandler}>
            <p className="view">Previous</p>
          </Link>
          <Button variant="primary" type="submit" className="green-btn mt-3">
            Save
          </Button>
        </div>
      </Form>
    </>
  );
};

export default Acknowledgement;
